import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Check, PriorityHigh } from '@mui/icons-material'
import { FilingStatus } from '../services/FilingStatus';
import './ReturnStatusIcon.scss'

const ReturnStatusIcon = ({ dashboardStatus, netfileStatus, isInline }) => {

    let colourClass = 'is-yellow'

    if (dashboardStatus === FilingStatus.IN_PROGRESS && (netfileStatus !== FilingStatus.REJECT && netfileStatus !== FilingStatus.ERROR)) {
        colourClass = 'is-yellow'
    } else if (dashboardStatus === FilingStatus.SUCCESS && (netfileStatus === FilingStatus.REJECT || netfileStatus === FilingStatus.ERROR)) {
        colourClass = 'is-red'
    } else if (dashboardStatus === FilingStatus.PAPERFILED || dashboardStatus === FilingStatus.SUCCESS) {
        colourClass = 'is-green'
    } else if ([FilingStatus.REFILED, FilingStatus.NETFILED, FilingStatus.FILED].includes(dashboardStatus) && netfileStatus !== FilingStatus.REJECT) {
        colourClass = 'is-green'
    } else if (dashboardStatus === FilingStatus.ERROR || netfileStatus === FilingStatus.REJECT || netfileStatus === FilingStatus.ERROR) {
        colourClass = 'is-red'    
    }
    
    return (
        <div className={isInline ? 'return-filing-status-in-line' : 'return-filing-status'}>
            <div className={classnames('icon-holder', colourClass)}>
                {colourClass.includes('is-green') && <Check />}
                {(colourClass.includes('is-yellow') || colourClass.includes('is-red')) && <PriorityHigh />}
            </div>
        </div>
    )
}

ReturnStatusIcon.propTypes = {
    dashboardStatus: PropTypes.string,
    netfileStatus: PropTypes.string
}

export default ReturnStatusIcon;
